/**
 * menu-item.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import ListItem from '@mui/material/ListItem';
import { NavLink } from "react-router-dom";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';


const useStyles = makeStyles(theme => ({
  menuItem: {
    borderRadius: theme.spacing(0.5),
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
    fontFamily: '"Source Sans Pro", sans-serif',
    textTransform: "uppercase",
    fontSize: "1rem",
    marginTop: theme.spacing(0.25),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
    },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.16)'
    }
  },
  menuItemIcon: {
    color: 'inherit',
    minWidth: theme.spacing(4),
  },
  nestedMenuItem: {
    paddingLeft: theme.spacing(5),
    textTransform: "initial",
  },
  active: {
    backgroundColor: theme.palette.sys.secondary,
    color: theme.palette.sys.onSecondary,
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: theme.palette.sys.secondaryContainer,
    },
  },
}));


// single menu item
// note: much of this logic exists to handle PT1 hard-links. 
// when we PT1-RETIRE we can simplify this greatly
export default function MenuItem (props) {
  const classes = useStyles();
  const Component = props.component;
  
  let newProps = {};

  if (props.route) {
    newProps = {
      exact: true,
      component: NavLink,
      to: props.route,
      activeClassName: classes.active,
      onClick: props.onClick
    };
  } else if (props.link) {
    newProps = {
      component: 'a',
      href: props.link,
      className: clsx({
        [classes.nestedMenuItem] : props.child,
        [classes.active] : props.active,
      }),
    };
  } else {
    newProps = {
      onClick: props.onClick
    };
  }

  newProps = {...newProps, ...(props.id ? { id: props.id } : {}) }; 

  return (
    <ListItem 
      button 
      {...newProps} 
      className={clsx({
        [classes.menuItem] : true,
        [classes.nestedMenuItem] : props.child,
        [classes.active] : props.active
      })} 
    >
      {props.component &&
      <Component menu />}

      {!props.component &&
      <>
        {props.icon && <ListItemIcon className={clsx({
          [classes.menuItemIcon] : true,
        })}>
          {props.icon}
        </ListItemIcon>}
        
        <ListItemText primary={props.title} disableTypography />

        {/* {props.parent && <>
          {props.open ? <ExpandLess /> : <ExpandMore />}
        </>} */}
      </>}
    </ListItem>
  );
}